// extracted by mini-css-extract-plugin
export default {"root":"Settings_root__a0rhV","content":"Settings_content__McTaX","item":"Settings_item__mdyVK","itemLabel":"Settings_itemLabel__8MNU1"};